(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    (function() {
    function initSlideshows() {
      document.querySelectorAll('.banner-slideshow').forEach(function(slideshow) {
        var slides = slideshow.querySelectorAll('.banner-slide');
        var dots = slideshow.querySelectorAll('.banner-dot');
        var prevBtn = slideshow.querySelector('.banner-arrow--prev');
        var nextBtn = slideshow.querySelector('.banner-arrow--next');
        var current = 0;
        var total = slides.length;
        var autoplayInterval = null;

        if (total <= 1) return;

        function goTo(index) {
          slides[current].classList.remove('banner-slide--active');
          if (dots[current]) dots[current].classList.remove('banner-dot--active');
          current = (index + total) % total;
          slides[current].classList.add('banner-slide--active');
          if (dots[current]) dots[current].classList.add('banner-dot--active');
        }

        function startAutoplay() {
          autoplayInterval = setInterval(function() {
            goTo(current + 1);
          }, 4000);
        }

        function stopAutoplay() {
          clearInterval(autoplayInterval);
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', function() {
            stopAutoplay();
            goTo(current + 1);
            startAutoplay();
          });
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function() {
            stopAutoplay();
            goTo(current - 1);
            startAutoplay();
          });
        }

        dots.forEach(function(dot, i) {
          dot.addEventListener('click', function() {
            stopAutoplay();
            goTo(i);
            startAutoplay();
          });
        });

        startAutoplay();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSlideshows);
    } else {
      initSlideshows();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
